import {StyleSheet} from "aphrodite";

import Button from "@khanacademy/wonder-blocks-button";
import {font, sizing} from "@khanacademy/wonder-blocks-tokens";

import caretLeftIcon from "@phosphor-icons/core/regular/caret-left.svg";

interface Props {
    /**
     * The URL to navigate to when the back link is clicked.
     */
    backUrl: string;
    /**
     * The text to display in the back link. Defaults to "Back".
     */
    text?: string;
    style?: React.CSSProperties;
}

/**
 * A back link that navigates to a specified URL.
 */
export const BackLink = ({text = "Back", backUrl, style}: Props) => {
    return (
        <Button
            kind="tertiary"
            startIcon={caretLeftIcon}
            href={backUrl}
            style={[styles.button, style]}
        >
            {text}
        </Button>
    );
};

const styles = StyleSheet.create({
    button: {
        fontSize: font.size.medium,
        marginInlineStart: `calc(-1 * ${sizing.size_080})`,
    },
});
